<div class="sh-form-row-with-action" style="flex-wrap: nowrap">
    @if ($showAI()) {
        <div class="ai-container" [title]="'search.ai-toggle' | translate">
            <span class="ai-label">{{ "search.ai" | translate }}</span>
            <label class="sh-toggle-switch__switch" htmlFor="ai-toggle">
                <input type="checkbox" id="ai-toggle" [formControl]="aiToggleControl" />
                <span class="sh-toggle-switch__slider"></span>
            </label>
        </div>
    }

    <div class="sh-form-row-with-action__inputs">
        <div class="sh-form-group sh-form-row-with-action__inputs__item">
            <sh-filter-tag-search
                #queryFilter
                [filter]="initialTagSearchFilter$ | async"
                [aiEnabled]="$aiEnabled()"
                [fullTextEnabled]="$fullTextEnabled()"
                [tagLimitedButtons]="tagLimitedButtons()"
                (filterChanged)="onSearchBarChange($event)"
            ></sh-filter-tag-search>
        </div>
    </div>
    @if ($searchBarActionItems().length) {
        <div class="sh-form-row-with-action__actions">
            @for (actionItem of $searchBarActionItems(); track actionItem) {
                <sh-action-item [item]="actionItem" class="sh-form-row-with-action__actions__item -sh-button-spacing"> </sh-action-item>
            }
        </div>
    }
</div>

@if ($showFullText()) {
    <div class="sh-form-row-with-action" style="flex-wrap: nowrap">
        @if ($showAI()) {
            <!-- Spacing container if AI toggle is shown -->
            <div style="width: 62px"></div>
        }
        <div class="sh-form-row-with-action__inputs">
            <div class="sh-form-check" style="max-width: fit-content">
                <input type="checkbox" id="full-text-toggle" [formControl]="fullTextToggleControl" class="sh-checkbox sh-form-check__input" />
                <label for="full-text-toggle" class="sh-form-check__label"
                    ><small>{{ "search.full-text-toggle" | translate }}</small></label
                >
            </div>
        </div>
    </div>
}
